interface FAQ {
  question: string;
  answer: string;
}

export const generalFAQ: FAQ[] = [
  {
    question: 'Wie läuft eine kostenlose Erstbegutachtung ab?',
    answer:
      'Wir vereinbaren einen Termin vor Ort, schauen uns Ihre Bäume an und besprechen mögliche Maßnahmen. Sie erhalten anschließend ein schriftliches Festpreis-Angebot. Beratung und Begehung sind unverbindlich und kostenlos.',
  },
  {
    question: 'Sind Sie versichert?',
    answer:
      'Ja. Wir sind über eine Betriebshaftpflicht versichert (Deckungssumme: TBD). Den Versicherungsschein zeigen wir Ihnen auf Wunsch vor Beginn der Arbeiten.',
  },
  {
    question: 'Brauche ich für eine Fällung eine Genehmigung?',
    answer:
      'In vielen Gemeinden gilt eine Baumschutzsatzung. Wir prüfen für Sie, ob Ihr Baum geschützt ist, und unterstützen bei der Antragstellung – inklusive Foto-Dokumentation und Begründung.',
  },
  {
    question: 'Wie schnell sind Sie bei einem Sturmschaden vor Ort?',
    answer:
      'Bei akuten Sturmschäden in unserem Einsatzgebiet sind wir in der Regel am selben Tag vor Ort, in vielen Fällen innerhalb weniger Stunden. Rufen Sie uns einfach an.',
  },
  {
    question: 'Was kostet eine Baumpflege oder Fällung?',
    answer:
      'Der Preis hängt von Größe, Standort, Erreichbarkeit und Aufwand der Entsorgung ab. Wir arbeiten mit Festpreisen – keine Stundensätze, keine Überraschungen. Das Angebot ist immer kostenlos.',
  },
  {
    question: 'Was passiert mit dem Schnitt- und Holzgut?',
    answer:
      'Standardmäßig entsorgen wir alles fachgerecht. Auf Wunsch lassen wir Brennholz vor Ort, häckseln das Schnittgut zu Mulch oder verarbeiten besondere Stämme zu Kantholz weiter.',
  },
  {
    question: 'Arbeiten Sie auch in engen Innenhöfen oder schwierigem Gelände?',
    answer:
      'Ja – das ist unser Spezialgebiet. Mit Seilklettertechnik und stückweisem Abtragen kommen wir auch dorthin, wo kein Kran hinpasst.',
  },
  {
    question: 'Wann ist der beste Zeitpunkt für einen Baumschnitt?',
    answer:
      'In der Regel die Vegetationsruhe (Oktober bis Februar) – außer beim Vogelschutz nach §39 BNatSchG: Stark einkürzende Schnitte und Fällungen sind von 1. März bis 30. September untersagt. Pflegeschnitte sind ganzjährig möglich.',
  },
];
